import { useEffect, useState } from "react";

import { adminApi, type RansomwareIncident, type SubsystemStatus } from "../api";
import { StatusTile } from "../components/StatusTile";

export function Ransomware(): JSX.Element {
  const [status, setStatus] = useState<SubsystemStatus | null>(null);
  const [incidents, setIncidents] = useState<RansomwareIncident[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [busyId, setBusyId] = useState<string | null>(null);

  function reload(): void {
    adminApi
      .get<SubsystemStatus>("/api/v1/admin/ransomware/status")
      .then(setStatus)
      .catch((err) => setError(err instanceof Error ? err.message : String(err)));
    adminApi
      .get<RansomwareIncident[]>("/api/v1/admin/ransomware/incidents")
      .then(setIncidents)
      .catch((err) => setError(err instanceof Error ? err.message : String(err)));
  }

  useEffect(reload, []);

  async function transition(id: string, target: string): Promise<void> {
    setBusyId(id);
    try {
      await adminApi.post(`/api/v1/admin/ransomware/incidents/${id}/transition`, { target });
      reload();
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusyId(null);
    }
  }

  const nextStatus: Record<string, string> = {
    open: "investigating",
    investigating: "contained",
    contained: "resolved",
  };

  return (
    <div>
      <h2 className="page-title">🛡️ Ransomware Defense</h2>
      <p className="page-subtitle">Open incidents from the behavior-signal / gated-commit engine.</p>
      {error && <div className="error-banner">{error}</div>}
      {status && (
        <div className="status-grid">
          <StatusTile status={status} />
        </div>
      )}
      <table>
        <thead>
          <tr>
            <th>Severity</th>
            <th>Status</th>
            <th>Reason</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {incidents.map((i) => (
            <tr key={i.id}>
              <td>{i.severity}</td>
              <td>{i.status}</td>
              <td>{i.reason}</td>
              <td>
                {nextStatus[i.status] && (
                  <button disabled={busyId === i.id} onClick={() => transition(i.id, nextStatus[i.status])}>
                    Move to {nextStatus[i.status]}
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
